import { Command } from 'cmdk'
import cx from 'src/utils/cx'

const CmdKItem = ({
  children,
  startIcon,
  endIcon,
  subtext = '',
  ...props
}: {
  children: React.ReactNode
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  subtext?: string
} & React.ComponentProps<typeof Command.Item>) => {
  return (
    <Command.Item
      className={cx(
        'content-visibility-auto min-h-4 flex cursor-pointer select-none items-center gap-2 rounded-lg px-2 py-1 text-sm text-gray-900 transition-all duration-150 ease-in-out',
        'hover:bg-gray-100 active:bg-gray-100',
        'first:mt-1 [&+&]:mt-0.5',
        'data-[selected=true]:bg-gray-100 data-[selected=true]:text-gray-900',
        'data-[disabled=true]:cursor-not-allowed data-[disabled=true]:text-gray-400',
        props.className
      )}
      {...props}
    >
      <div className="flex w-full items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          {startIcon && startIcon}
          {children}
        </div>
        {subtext && <span className="text-xs text-gray-500">{subtext}</span>}
        {endIcon && endIcon}
      </div>
    </Command.Item>
  )
}

export default CmdKItem
